import {useEffect} from 'react';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {BackLink} from '../../../components';
import {useAmplitude} from '../../../context';
import {useLinearFlowContext} from '../../../layouts';
import {
    ContinueButton,
    Instruction,
} from '../components';

export function SpitAndClose() {
    const amplitude = useAmplitude();
    const intl = useIntl();
    const {onBackLinkClickHandler} = useLinearFlowContext();

    useEffect(() => {
        amplitude.logActivationSpitVisit();
    }, [amplitude]);

    return (
        <>
            <BackLink onClick={onBackLinkClickHandler} />
            <h2 data-test-id={'kit-activation-step-three-title'}>
                <FormattedMessage id={'kit.activation.stepThree.title'} />
            </h2>
            <Instruction
                image={'/images/kit-activation-three-one.svg'}
                text={intl.formatMessage({id: 'kit.activation.stepThree.instruction.one'})}
            />
            <Instruction
                className={'more-margin'}
                image={'/images/kit-activation-three-two.svg'}
                text={intl.formatMessage({id: 'kit.activation.stepThree.instruction.two'})}
            />
            <ContinueButton />
        </>
    );
}
